module.exports = __webpack_public_path__ + "img/safari.660b9e20.svg";